import apiClient from "../../axios/apiClient";

export const getSubCheckList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_SUBCHECKLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Sub-Checklist`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_SUBCHECKLIST_FULFILLED",
        payload: response.data?.data,
        subChecklistCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_SUBCHECKLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveSubCheckData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_SUBCHECKLIST_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Sub-Checklist`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_SUBCHECKLIST_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_SUBCHECKLIST_REJECTED", payload: error.response });
    }
  };
  

  export const getSubCheckListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_SUBCHECKLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Sub-Checklist/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_SUBCHECKLISTBYID_FULFILLED",
        payload: response.data?.data,
        subchecklistCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_SUBCHECKLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateSubCheckData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_SUBCHECKLIST_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Sub-Checklist/${id}`, // Endpoint URL with SubCheck ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_SUBCHECKLIST_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_SUBCHECKLIST_REJECTED", payload: error.response });
  }
};


export const updateSubCheckStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_SUBCHECKLIST_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Sub-Checklist-Status/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_SUBCHECKLIST_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_SUBCHECKLIST_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteSubCheckData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_SUBCHECKLIST_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Sub-Checklist/${id}`, // Endpoint URL with SubCheck ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_SUBCHECKLIST_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_SUBCHECKLIST_REJECTED", payload: error.response });
  }
};